import React, { useEffect, useState, useMemo } from 'react'
import { Typography, makeStyles, CircularProgress } from '@material-ui/core'
import { isClientRole } from '../../../../Utils/Validators/roles'
import { useSelector, connect } from 'react-redux'
import { useHistory, useRouteMatch, withRouter } from 'react-router-dom'
import { UserManagementIcon } from '../../../../Assets/Images/icons/UserManagementIcon'
import { updateUserById, getUserById } from '../../../../Reducers/Users/actions'
import { uploadProfileImage } from 'Reducers/Upload/actions'
import { PATHS } from '../../../../Config/Routing/paths'
import { ProfileInfo } from './ProfileInfo'
import { ProfileEditForm } from './ProfileEditForm'
import { styles } from './styles'
import StyledBreadcrumbs from '../../../../Components/StyledBreadcrumbs'
import classNames from 'classnames'
import ArrowBackIcon from '../../../ClientSettings/icons/ArrowBackIcon'

const useStyles = makeStyles(() => styles)

const UserProfileComponent = props => {
  const state = useSelector(state => state)
  const match = useRouteMatch()
  const classes = useStyles()
  const {
    users: { userById },
  } = state
  const history = useHistory()
  const [edit, setEdit] = useState(false)
  const user = useMemo(() => userById || {}, [userById])
  const [saving, setSaving] = useState(false)
  const isEdit = useMemo(() => match.path.split('/').pop() === 'edit', [match])

  useEffect(() => {
    if (!Object.values(user).length) {
      props.getUserById(match.params.userId)
    }
  }, [user])

  useEffect(() => {
    if (isEdit && !edit) {
      setEdit(isEdit)
    }
  }, [isEdit])

  const userManagementDetailsEditFormSubmit = values => {
    if (JSON.stringify(values) === JSON.stringify(user)) {
      return
    }
    setSaving(true)
    const { updateUserById, uploadProfileImage, getUserById } = props
    const { userId } = match.params
    const payload = imageUrl => {
      const additionalProp = {}

      if (!isClientRole(values.role)) {
        additionalProp.city_id = values.cityId
      }

      return {
        client_id: values.client.id,
        first_name: values.firstName,
        last_name: values.lastName,
        mobile_phone: values.mobilePhone,
        email: values.email,
        profile_picture: imageUrl,
        role: values.role,
        ...additionalProp,
      }
    }
    const callbacks = {
      onSuccess: () => {
        getUserById(userId)
        userManagementDetailsEditFormSuccess()
      },
    }

    const imageFile = values.profilePicture
    if (imageFile.type) {
      uploadProfileImage(userId, imageFile, {
        onSuccess: imageUrl => {
          updateUserById(userId, payload(imageUrl), callbacks)
        },
      })
    } else {
      updateUserById(userId, payload(), callbacks)
    }
  }

  const userManagementDetailsEditFormSuccess = () => {
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}${
        PATHS.clientSettings.userManagement
      }`,
    )
  }

  if (!userById || !Object.values(userById).length) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress />
      </div>
    )
  }

  const onBack = () => {
    history.push(
      PATHS.main.dashboard +
        PATHS.dashboard.clientSettings +
        PATHS.clientSettings.userManagement,
    )
  }

  return (
    <div
      className={classNames(
        classes.profileContainer,
        'makeStyles-profileContainer',
      )}
    >
      <StyledBreadcrumbs
        icon={<UserManagementIcon />}
        breadcrumbs={[
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}`,
            label: 'Settings',
          },
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}${
              PATHS.clientSettings.userManagement
            }`,
            label: 'User Management',
          },
          {
            label: `${user.firstName} ${user.lastName}`,
          },
          {
            label: edit ? 'Edit User' : 'User Details',
          },
        ]}
      />
      <Typography className={classes.profileTitle}>
        <div className={classes.back} onClick={onBack}>
          <ArrowBackIcon />
        </div>
        <div>User Details</div>
      </Typography>
      <div
        className={classNames(
          classes.profileContent,
          'makeStyles-profileContent',
        )}
      >
        {!edit ? (
          <ProfileInfo user={userById} />
        ) : (
          <ProfileEditForm
            user={userById}
            handleSave={userManagementDetailsEditFormSubmit}
            saving={saving}
            edit={edit}
            setEdit={setEdit}
          />
        )}
      </div>
    </div>
  )
}

export const UserProfile = connect(
  null,
  {
    updateUserById,
    uploadProfileImage,
    getUserById,
  },
)(withRouter(UserProfileComponent))
